<div
    class="spinner-fullscreen"
    [class.hide]="!show"
    [class.primary]="color == 'primary'"
    [class.secondary]="color == 'secondary'"
>
    <img class="logo" [src]="color == 'primary' ? (primary$ | async) : (secondary$ | async)" />
    <mat-spinner class="loading" [color]="color" diameter="200"></mat-spinner>
</div>
